import React from "react";
import { Card, Row, Col, Typography } from "antd";
import { FaUser, FaStamp, FaGift } from "react-icons/fa";

const { Title } = Typography;

const ShopStatistics = ({ statistics, isLoading }) => {
  const stats = [
    {
      icon: <FaUser className="feature-icon" />,
      title: "Toplam Müşteri",
      value: statistics?.customerCount || 0,
    },
    {
      icon: <FaStamp className="feature-icon" />,
      title: "Toplam Damga",
      value: statistics?.stampCount || 0,
    },
    {
      icon: <FaGift className="feature-icon" />,
      title: "Toplam Ödül",
      value: statistics?.rewardCount || 0,
    },
  ];

  return (
    <div
      className="shop-statistics"
      style={{ marginBottom: "24px", marginTop: "24px" }}>
      <Card title="Mağaza İstatistikleri" type="inner">
        <Row gutter={[24, 24]}>
          {stats.map((stat, index) => (
            <Col xs={24} sm={24} md={8} lg={8} key={index}>
              <Card
                loading={isLoading}
                style={{
                  textAlign: "center",
                  height: "100%",
                  transition: "all 0.3s ease",
                }}
                hoverable>
                <div
                  style={{
                    fontSize: "2.5rem",
                    color: "#1890ff",
                    marginBottom: "16px",
                  }}>
                  {stat.icon}
                </div>
                <Title level={4}>{stat.title}</Title>
                <Title level={2} style={{ color: "#1890ff" }}>
                  {stat.value}
                </Title>
              </Card>
            </Col>
          ))}
        </Row>
      </Card>
    </div>
  );
};

export default ShopStatistics;
